import { CDialog } from "@appcues/component-library";
import React from "react";
import styled from "styled-components";

import salesforceImg from "assets/images/salesforce-integration.png";
import hubspotImg from "assets/images/hubspot-integration.png";

const StyledImage = styled.img`
  max-width: 400px;
`;

const IntegrationImage = ({ integrationId }) => {
  const altText =
    integrationId === "salesforce"
      ? "Appcues <> Salesforce Integration"
      : "Appcues <> Hubspot Integration";

  const imageSrc = integrationId === "salesforce" ? salesforceImg : hubspotImg;

  return (
    <CDialog.Header>
      <StyledImage alt={altText} src={imageSrc} />
    </CDialog.Header>
  );
};

export default IntegrationImage;
